import { render, staticRenderFns } from "./Memo.vue?vue&type=template&id=f12db6cc&scoped=true&"
import script from "./Memo.vue?vue&type=script&lang=ts&"
export * from "./Memo.vue?vue&type=script&lang=ts&"
import style0 from "./Memo.vue?vue&type=style&index=0&id=f12db6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12db6cc",
  null
  
)

export default component.exports